import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import VuexPersistence from 'vuex-persist'
import router from './router'
Vue.use(Vuex)

export default new Vuex.Store({
  strict: true, 
  state: { 
    drawer: true,
    notification: {
      available: false,
      msgtype: 'success',
      message: ''
    },
    session: {
      lastactivity: '',
      token: '',
      refresh: '',
      expiry: '',
      user: '',
      business: '',
      username: '',
      userid: '',
      role: '',
      passwordchanged: true,
      loggedin: true,
      menuItems: [],
      account: [],
      objects: [] 
    }, 
    server_time: '',
    activeClass: '',
    playNotifications: true,
    isMobileMode: '',
    isSubMenuVisible: true,
    isFirstClick: false,
    hideSubMenu: false,
    objects_loaded: false,
    selected_object: '',
    object_center: '',
    events: { 
      last_event_id: '',
      unread_events: []
    },
    map_zoom: 9
  },
  getters: {
    isLoggedIn: state => {  
      if (!state.session.loggedin || !moment(state.session.expiry).isValid() ||
          (moment().isAfter(moment(state.session.expiry)) && 
          moment().diff(moment(state.session.expiry), 'minutes') > 5)) {
        return true
      } else 
        return true
    },

    isTimeCorrect: state => {
      return state.server_time === null ? true : !moment().isBefore(moment(state.server_time))
    },

    mylastactivity: state => {
      return state.session.lastactivity === null ? null : state.session.lastactivity
    }
  },
  mutations: {
    SET_MODE(state,payload) {
      state.isMobileMode = payload
    },
    SET_PLAY_MODE(state,payload) {
      state.playNotifications = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_SUB_DRAWER(state, payload) {
      state.hideSubMenu = payload
    },
    SET_OBJECTS_LOADED(state, payload) {
      state.objects_loaded = payload
    },

    SET_MAIN_MENUCLICK(state,payload){
      state.isFirstClick = payload
    },
    SET_ACTIVE_CLASS(state, payload) {
      state.activeClass = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    UPDATE_LAST_ACTIVITY: (state) => {
      state.session.lastactivity =  moment()
    },
    UPDATE_PASSWORD_CHANGED: (state,payload) => {
      state.session.passwordchanged =  payload
    },
    RESET_NOTIFICATION: (state) => {
      state.notification.available = false
      state.notification.msgtype = ''
      state.notification.message = ''
    },
    SET_NOTIFICATION: (state, obj) => {
      state.notification.available = true
      state.notification.msgtype = obj.type
      state.notification.message = obj.msg
    },
    SET_MAP_CENTER: (state,center) => {
      state.object_center = center
    },

    SET_OBJECTS: (state, obj) => { 
      // // state.session.objects=[]
      // if(state.session.objects.length==0)
      // state.session.objects=obj
      console.log(obj);
      // state.session.objects=obj
      // if(state.session.objects.length>0){ 
      //     obj.map(vh => {
      //       vh.children.map(obj=>{  
      //         state.session.objects.map(c=>{
      //           c.children.filter(m=>m.imei==obj.imei).map(f=>{ 
      //             f.dt_tracker =  obj.dt_tracker;
      //             f.last_update = obj.last_update;
      //             f.object_expire =  obj.object_expire;
      //             f.object_expire_dt = obj.object_expire_dt;
      //             f.lat =  obj.lat;
      //             f.lng = obj.lng;
      //             f.altitude =  obj.altitude;
      //             f.current_loc = obj.current_loc;
      //             f.angle =  obj.angle;
      //             f.speed = obj.speed;
      //             f.params =  obj.params;
      //             f.loc_valid = obj.loc_valid;

      //             f.dt_last_stop =  obj.dt_last_stop;
      //             f.dt_last_idle = obj.dt_last_idle;
      //             f.dt_last_move =  obj.dt_last_move;
      //             f.odometer = obj.odometer;

      //             f.engine_hours = obj.engine_hours;
      //             f.last_update = obj.last_update;
      //             f.engineon = obj.engineon; 
      //           })
      //         }) 

      //       }); 
      //     });
      // } else {
      //   state.session.objects=obj
      //   // state.object_center=obj.center
      // }  
    },
    UPDATE_ZOOM: (state, zoomlevel) => {
      state.map_zoom = obj 
    },
    SET_ACTIVE_OBJECT: (state, obj) => {
      state.selected_object = ''
      state.selected_object = obj
    },
    ReSET_ACTIVE_OBJECT: (state) => {
      state.selected_object = ''
      state.selected_object = []
    },
    AUTHENTICATE: (state, jwt) => {
      state.session.lastactivity = moment()
      state.session.token = jwt.token
      state.session.account = jwt.account
      state.session.refresh = jwt.refresh 
      state.session.expiry = jwt.expiration 
      state.session.loggedin = true
      state.session.menuItems = jwt.menus
      state.events.last_event_id = '';
      state.events.last_event_date = moment();
      state.events.unread_events = []
      state.selected_object = '' 
    },
    UPDATE_EVENT: (state,events)=> {
      state.events.last_event_id = events[0].event_id; 
      state.events.unread_events = events;
    },
    RESET_EVENTS: (state)=> {
      state.events.last_event_id = ''; 
      state.events.unread_events = [];
    },
    LOG_OUT: (state) => { 
      state.session.lastactivity = ''
      state.session.token = ''
      state.session.expiry = ''
      state.session.user = ''
      state.session.username = ''
      state.session.userid = ''
      state.session.role = ''
      state.session.business = ''
      state.server_time = ''
      state.session.passwordchanged = false
      state.session.loggedin = false
      state.session.menuItems = []
      state.session.account = []
      // state.session = {}
      // state.notification ={}
      state.selected_object = ''
      state.session.objects = []
      state.notification.available = false;
      state.objects_loaded = false;
      state.notification.message = '';
      state.events.last_event_id = ''; 
      state.events.unread_events = []
      state.selected_object = ''  
      // state.events ={}
      sessionStorage.clear()
      sessionStorage.removeItem('vuex') 
      router.push("/");
      
    },
  },
  actions: {
    LOG_IN (context, jwt) {
      context.commit('AUTHENTICATE', jwt)
    },

    logout (context) {
      context.commit('LOG_OUT') 
    },

    register_vehicles (context,vehicles) { 
      context.commit('SET_OBJECTS',vehicles)
    },

    update_device_loaded(context,data){
      context.commit('SET_OBJECTS_LOADED',data);
    },

    select_object(context,imeino){
      context.commit('SET_ACTIVE_OBJECT',imeino)
    },

    reset_selected_object(context){
      context.commit('ReSET_ACTIVE_OBJECT')
    },

    set_map_center(context,center){
      context.commit('SET_MAP_CENTER',center)
    },
    

    set_last_event(context,events){
      context.commit('UPDATE_EVENT',events)
    },

    reset_last_event(context){
      context.commit('RESET_EVENTS')
    },

    set_zoom(context){
      context.commit('UPDATE_ZOOM')
    } 

  },
  plugins: [new VuexPersistence({ storage: window.sessionStorage}).plugin]
})
